import { UserLocalStorageService } from './../../permission/services/user.local.storage.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  DashboardAll,
  OverviewRequest,
  StatusRequest,
  TodoListRequest,
} from '../models/dashboard/agency-dashboard';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

@Injectable()
export class AgencyDashboardService {
  private agencyDashboardUrl: string = this.environment.agencyDashboardUrl + '/rest/private/dashboard';

  constructor(
    private http: HttpClient,
    private environment: EnvironmentConfiguration,
    private userLocalStorageService: UserLocalStorageService,
  ) {}

  // getall method with a http POST request with a json payload
  getAll(agencyCode: string): Observable<DashboardAll> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.userLocalStorageService.getToken()
    });

    const options = {
      headers: headers
    };

    let bodyContent = JSON.stringify({
      section: 'all',
      timeframe: 'all',
      type: 'agency',
      code: agencyCode,
    });

    return this.http.post<DashboardAll>(this.agencyDashboardUrl, bodyContent, options);
  }

  getStatus(agencyCode: string, timeframe: string): Observable<StatusRequest> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.userLocalStorageService.getToken()
    });

    const options = {
      headers: headers
    };

    let bodyContent = JSON.stringify({
      section: 'status',
      timeframe: timeframe,
      type: 'agency',
      code: agencyCode,
    });

    return this.http.post<StatusRequest>(this.agencyDashboardUrl, bodyContent, options);
  }

  getOverview(
    agencyCode: string,
    timeframe: string
  ): Observable<OverviewRequest> {

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.userLocalStorageService.getToken()
    });

    const options = {
      headers: headers
    };

    let bodyContent = JSON.stringify({
      section: 'overview',
      timeframe: timeframe,
      type: 'agency',
      code: agencyCode,
    });

    return this.http.post<OverviewRequest>(
      this.agencyDashboardUrl,
      bodyContent,
      options
    );
  }

  getTodoList(
    agencyCode: string,
    timeframe: string
  ): Observable<TodoListRequest> {

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.userLocalStorageService.getToken()
    });

    const options = {
      headers: headers
    };

    let bodyContent = JSON.stringify({
      section: 'todolist',
      timeframe: timeframe,
      type: 'agency',
      code: agencyCode,
    });

    return this.http.post<TodoListRequest>(
      this.agencyDashboardUrl,
      bodyContent, options
    );
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/agency-dashboard.http.service.ts